import axios from 'axios';
import {backendHost} from '../../config';

export const putOfferActive = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/offer/active`, params);
};